import React, {PureComponent} from "react"
import {get} from "lodash"

import client, {Query, pagination} from "@irati/utils/services/apollo"
import {CheckoutRedemptionList, CheckoutRedemption} from "@irati/types"
import {QueryCheckoutRedemptionsArgs} from "@irati/types/ops"
import {QueryComponentProps as BaseQueryComponentProps} from "@irati/utils/services/apollo/Query"
import {ApolloState as BaseApolloState} from "@irati/utils/services/apollo/apolloStateInterface"

import redemptionQuery, {redemptionListQueryKey} from "../../services/queries/redemptions"

export const query = redemptionQuery

export interface RedemptionsApolloState extends BaseApolloState<{redemptions: CheckoutRedemptionList}, QueryCheckoutRedemptionsArgs> {}
export interface QueryComponentProps
  extends BaseQueryComponentProps<{redemptions: CheckoutRedemptionList}, QueryCheckoutRedemptionsArgs> {}

export function getRedemptionList(apollo: RedemptionsApolloState) {
  const redemptions: CheckoutRedemptionList = get(apollo, `data[${redemptionListQueryKey}]`, {})
  const {results = [], cursor, limit, hasMore, offset} = redemptions

  return {
    results,
    limit,
    cursor,
    hasMore,
    offset
  }
}

export function removeFromRedemptionList(redemption: CheckoutRedemption, variables: QueryCheckoutRedemptionsArgs) {
  const data = client.readQuery({query, variables})
  if (data) {
    const {checkoutRedemptions} = data
    const newRedemptionList = checkoutRedemptions.results.filter((t: CheckoutRedemption) => {
      return t.uuid !== redemption.uuid
    })

    client.writeQuery({
      query,
      variables,
      data: {
        [redemptionListQueryKey]: {
          ...checkoutRedemptions,
          results: newRedemptionList
        }
      }
    })
  }
}

interface Props extends Omit<QueryComponentProps, "query"> {}

export default class RedemptionListQuery extends PureComponent<Props> {
  render() {
    const {children, ...props} = this.props

    return (
      <Query {...props} query={query} useLoader={false}>
        {(apollo: RedemptionsApolloState) => {
          const nextPage = (nextPageVariables: QueryCheckoutRedemptionsArgs) => pagination({query, variables: nextPageVariables}, apollo)
          return children({...apollo, nextPage})
        }}
      </Query>
    )
  }
}
